__turbopack_context__.v({
  "ratingSnippet": "bDr7DG_ratingSnippet",
});
